const translate = {
    install (Vue) {
        Vue.prototype.$_t = function (msg) {
            // use this to turn on translations
            return this.$t(msg)

            // use this to only show untranslated text
            // console.log(msg)
            // return '-'
        }
    }
}

export default translate
